import { type ReactNode } from 'react';
import { PortalDashboardView } from './PortalDashboardView.js';

/**
 * M42 §27 VendorPortalDashboard — the vendor stakeholder landing surface (§17).
 * Renders the shared responsive dashboard view scoped to the VENDOR segment.
 */
export function VendorPortalDashboard(): ReactNode {
  return <PortalDashboardView segment="Vendor" defaultType="VENDOR" />;
}
